import UiTypography from '@devdept/samolet-ui/lib/components/Typography';
import styled from 'styled-components';

const Typography = styled(UiTypography)``;

export const TypographyTitle = Typography.Title;
export const TypographyText = Typography.Text;
export const TypographyParagraph = styled(Typography.Paragraph)`
  margin-bottom: 0 !important;
`;
